const TECHNICAL_ERROR_PATTERNS = [
  /accessToken/i,
  /clientRequestId/i,
  /Manifest/i,
  /\bV2\b/i,
  /\bGLM\b/i,
  /\bHTTP\b/i,
  /LibreOffice/i,
  /服务器/,
  /服务端/,
  /后端/,
  /数据库/,
  /SQL/i,
]

export const normalizeUserFacingError = (error, fallback = '操作失败，请稍后重试') => {
  const rawMessage = error?.response?.data?.errorMessage
    || error?.response?.data?.message
    || error?.message
    || ''
  const message = String(rawMessage || '').trim()

  if (!message || TECHNICAL_ERROR_PATTERNS.some((pattern) => pattern.test(message))) {
    return fallback
  }

  return message
}
